import keycloak from '@/plugins/keycloak';
import store from '@/store';

export function requireAuth(to, from, next) {
  if (!keycloak.authenticated) {
    // Redireciona para login Keycloak
    keycloak.login({ redirectUri: window.location.origin + to.fullPath });
  } else {
    // Sincroniza Vuex se ainda não estiver
    if (!store.state.isAuthenticated) {
      store.commit('setIsAuthenticated', keycloak.authenticated);
      store.commit('setUserData', keycloak.idTokenParsed);
      store.commit('setToken', keycloak.token);
      store.commit('setResourceAccess', keycloak.resourceAccess);
    }
    next();
  }
}
